import { render } from "./start.vue?vue&type=template&id=7237ce6c"
import script from "./start.vue?vue&type=script&lang=js"
export * from "./start.vue?vue&type=script&lang=js"

import "./start.vue?vue&type=style&index=0&id=7237ce6c&lang=sass"
script.render = render

export default script